// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YXil","largestCol":"styles_largestCol__2gNvO","smallestCol":"styles_smallestCol__11bL3"};